import React, {useState, useEffect} from "react";

// Styles
import "./Depths.scss";
import {Col, Container, Row} from "react-bootstrap";

// Image Imports
import depthsTEGLogo from "../../../../images/depths_teg_logo.png";
import depthsLogo from "../../../../images/depths_logo.png";

// Component Imports
import PlayerClueModule from "../../PlayerClueModule/PlayerClueModule";
import PlayerMediaModule from "../../PlayerMediaModule/PlayerMediaModule";
import PlayerInventoryModule from "../../PlayerInventoryModule/PlayerInventoryModule";
import PlayerMultiRowInventoryModule from "../../PlayerMultiRowInventoryModule/PlayerMultiRowInventoryModule";
import PlayerZoomDownload from "../../PlayerZoomDownload/PlayerZoomDownload";

import {getBackground, VdayHearts} from "../getBackground";

const Depths = (props) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const inventoryType = params.get('inventory');
  useEffect(() => {
    document.body.style.backgroundColor = "#0ea0a8";
  }, [])
  return (
    <div className={props.theme}>
      <div className="player-wrapper" style={{backgroundImage: `url(${getBackground(props.theme)})`}}>
        <Container fluid>
          <Row className="player-logo-section">
            <div className='logo-container'>
              <img
                alt="Logo for The Escape Game"
                className="player-logos-1"
                src={depthsTEGLogo}
              />
              <img
                alt="Logo for The Escape Game's Ruins escape room"
                className="player-logos-2"
                src={depthsLogo}
              />
            </div>
          </Row>
          <Row>
            <Col md="12">
              <VdayHearts />
              <PlayerMediaModule
                scans={props.scans}
                socket={props.socket}
                videos={props.videos}
                theme={props.theme}
                gameMedia={props.gameMedia}
              />
              <br/>
              <Row>
                {props.gameMedia.lockInventory && props.gameMedia.lockInventory.length ? <Col md='6'>
                  <PlayerInventoryModule
                    currentInventory={props.inventory}
                    inventory={props.gameMedia.lockInventory}
                    socket={props.socket}
                    theme={props.theme}
                    type={'lock'}
                  />
                </Col> : ''
                }
                <Col md={props.gameMedia.lockInventory.length ? 6 : 12}>
                  <PlayerZoomDownload conferenceApp="ZOOM" theme={props.theme} tracking={props.gameMedia.tracking} />
                </Col>
              </Row>
              <Row className="no-show">
                <Col md="7">
                  <PlayerClueModule clue={props.clue} socket={props.socket} game={props.game}/>
                </Col>
                <Col md="5">
                  <Row>
                    <h1>Time</h1>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="my-50">
            {inventoryType === 'multi-row' ?
              <PlayerMultiRowInventoryModule
                currentInventory={props.inventory}
                inventory={props.gameMedia.baseInventory}
                socket={props.socket}
                theme={props.theme}
                type={'base'}
              />:
              <PlayerInventoryModule
                currentInventory={props.inventory}
                inventory={props.gameMedia.baseInventory}
                socket={props.socket}
                theme={props.theme}
                type={'base'}
              />
            }
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Depths;
